module.exports = __webpack_public_path__ + "img/07-融创茂.5380365c.jpg";